import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMoonStar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMoonStar"><Path d="M21.5 11.9943C20.3396 12.9358 18.8607 13.5 17.25 13.5C13.5221 13.5 10.5 10.4779 10.5 6.75C10.5 5.13929 11.0642 3.66035 12.0057 2.5L12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C17.2467 21.5 21.5 17.2467 21.5 12L21.5 11.9943Z" stroke="currentColor" strokeLinecap="round"/><Path d="M17.8 3.5H17.2L16.45 5.45L14.5 6.2V6.8L16.45 7.55L17.2 9.5H17.8L18.55 7.55L20.5 6.8V6.2L18.55 5.45L17.8 3.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconMoonStar;
